import * as React from "react";
import {useState} from "react";
import {IconButton, Menu, MenuItem} from "@material-ui/core";

interface IOption {
  id: string
  content: string
  onClick: () => void
}

export interface IDropdown {
  label: string
  id: string
  options: IOption[]
}

// ToDo: sprawwić by te zmienne były zależne od cssów
const buttonHeight = 24
const spaceFromButton = 10

const anchorOrigin = {
  vertical: buttonHeight + spaceFromButton,
  horizontal: 'right'
} as const

export const Dropdown = ({
  label,
  id,
  options
}: IDropdown) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="dropdown__button"
        aria-label={label}
        aria-controls={id}
        aria-haspopup="true"
        onClick={handleClick}
        disableRipple
      >
        <img src="/images/icons/dots.svg"/>
      </IconButton>
      <Menu
        className="dropdown__menu"
        id={id}
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        keepMounted
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={anchorOrigin}
      >
        {options.map((option) => (
          <MenuItem key={option.id} onClick={() => {
            option.onClick()
            handleClose()
          }}>
            {option.content}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}



// WEBPACK FOOTER //
// ./src/components/Layout/Dropdown/Dropdown.Component.tsx